module.exports = __webpack_public_path__ + "./images/8c3c73e6526b7fe0d78ca099210fb368.webp";